import { createSlice } from "@reduxjs/toolkit";

const pendingSlice = createSlice({
  name: "pending",
  initialState: false,
  reducers: {
    setPendingTrue: () => {
      return true;
    },
    setPendingFalse: () => {
      return false;
    },
  },
});

export const { setPendingFalse, setPendingTrue } = pendingSlice.actions;
export default pendingSlice.reducer;
